const routes = [
  {
    path: '*',
    redirect: '/layout',
  },
  {
    path: '/layout',
    component: () => import('@/views/layout/layout'),
    children: [
      {
        path: '',
        redirect: 'home',
      },
      {
        path: 'home',
        component: () => import('@/views/home/home'),
      },
      {
        path: 'product',
        component: () => import('@/views/product/product'),
      },
      {
        path: 'brand',
        component: () => import('@/views/brand/brand'),
      },
      {
        path: 'development',
        component: () => import('@/views/development/development'),
      },
      {
        path: 'about',
        component: () => import('@/views/about/about'),
      },
      {
        path: 'certificate',
        component: () => import('@/views/certificate/certificate'),
      }
    ]
  },
]
export default routes



// WEBPACK FOOTER //
// ./src/router/routers.js